import { createContext, useContext } from "react";
import { DEFAULT_BUSINESS_TYPE, completenessRule } from "./businessPreset";

// The signed-in business's type (see src/businessPreset.js), shared with every screen so each one labels costs
// and counts missing labor the same way. Without a provider (demo, tests) screens get Trades, which is the
// app's original behavior.
const BusinessTypeContext = createContext(DEFAULT_BUSINESS_TYPE);

// Returns { businessType, rule }. rule goes straight into jobCompleteness(job, pending, rule).
function useBusinessType() {
  const businessType = useContext(BusinessTypeContext);
  return { businessType, rule: completenessRule(businessType) };
}

export { BusinessTypeContext, useBusinessType };
